import * as React from 'react';

export default props => (
    <svg viewBox='0 0 24 24' {...props} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M11.907 20l.01-.038c.081-.324.157-.685.227-1.082l.88-4.976h1.6l.224-1.088h-1.632l.496-2.208c.064-.277.173-.485.328-.624.155-.139.376-.208.664-.208h.944l.224-1.2h-1.184c-.683 0-1.235.192-1.656.576-.421.384-.69.88-.808 1.488l-.416 2.176h-1.456l-.208 1.088h1.472l-1.12 5.904-.036.192H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5h-7.093z"
                fillOpacity=".54" fill="#3E4554" fillRule="nonzero" />
        </g>
    </svg>
)
